<ng-container *transloco="let convert;">
  @if (dealerList()) {
    <div class="">
      @if (!isSearchBoxDisabled) {
        <div class="form-group">
          <label class="text-uppercase d-block"
            >{{ convert('common.labelSearch') }}
            <input type="text" class="form-control" (input)="search($event)" />
          </label>
        </div>
      }
      @if (dealerList()) {
        <div>
          <ul>
            @if (dealerList()?.length > 1) {
              <li class="custom-control custom-checkbox">
                <input
                  class="custom-control-input"
                  id="dealer-option-1"
                  type="checkbox"
                  data-track-elem="checkbox"
                  data-track-trigger="filter"
                  data-track-name="Select All"
                  [checked]="isSelectAllButtonChecked$()"
                  (change)="toggleSelectAll()"
                  aria-labelledby="dealer-option-1__label"
                  />
                <label id="dealer-option-1__label" class="custom-control-label ms-2" for="dealer-option-1"
                  >{{ convert('sellModule.manageInventory.dealerFilter.labelSelectAll') }}</label
                  >
                </li>
              }
              @for (dealer of computedDealerList | slice: 0:(isShowAll()) ? computedDealerList.length : initialDealersShown; track dealerById($index, dealer)) {
                <li
                  class="custom-control custom-checkbox"
                  >
                  <input
                    class="custom-control-input"
                    [attr.id]="'dealer-offers-' + dealer.value"
                    type="checkbox"
                    [checked]="isDealerSelected(dealer.value)"
                    data-track-elem="checkbox"
                    data-track-trigger="filter"
                    [attr.data-track-name]="dealer.name"
                    [value]="dealer.value"
                    [attr.aria-labelledBy]="'dealer-offers-' + dealer.value + '__label'"
                    (change)="toggleDealer(dealer.value)"
                    />
                  <label
                    [attr.id]="'dealer-offers-' + dealer.value + '__label'"
                    class="custom-control-label ms-2 dealer-name-word-break"
                    [attr.for]="'dealer-offers-' + dealer.value"
                    >{{ dealer.name }}</label
                    >
                  </li>
                }
              </ul>
              @if (computedDealerList?.length > initialDealersShown) {
                <button
                  class="text-primary fw-bold btn-link"
                  (click)="toggleShowAll()"
                  [appTrackButton]="!isShowAll() ? btnShowMore() : convert('search.common.collapsableList.btnShowLess')"
                  >
                  {{ !isShowAll() ? btnShowMore() : convert('search.common.collapsableList.btnShowLess') }}
                </button>
              }
            </div>
          }
        </div>
      }
    </ng-container>
